"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseDialogIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const CloseDialogIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props),
    react_1.default.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.9498 15.5355L15.5356 16.9497L12.0001 13.4143L8.46466 16.9497L7.05044 15.5355L10.5859 12.0001L7.05029 8.46445L8.46451 7.05023L12.0001 10.5859L15.5357 7.05025L16.9499 8.46447L13.4143 12.0001L16.9498 15.5355Z" })));
exports.CloseDialogIcon = CloseDialogIcon;
exports.default = exports.CloseDialogIcon;
